export default "__VITE_ASSET__17fa2167__"